module.exports = __webpack_public_path__ + "img/sidebar-right-idle-icon.58016b19.svg";